import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { t } from '../../../../helpers/t';
import FilterWrapper from '../../FilterWrapper';

const { Option } = Select;

const ORDER_BY_OPTIONS = [
  { label: 'Recommended', value: 'score DESC' },
  { label: 'Price - Low to High', value: 'daily_price ASC' },
  { label: 'Price - High to Low', value: 'daily_price DESC' },
  { label: 'Size - Largest to Smallest', value: 'size DESC' },
  { label: 'Size - Smallest to Largest', value: 'size ASC' },
  { label: 'Distance', value: 'distance ASC' },
  { label: 'Recently Listed', value: 'published_at DESC' },
];

const DEFAULT_FILTER_VALUE = ORDER_BY_OPTIONS[0].value;

const SelectOption = ({ label, value }) => <Option key={value} value={value}>{t(`directives.listings.listingFilters.${label}`)}</Option>;

const SortSelector = ({ updateSearchFilters, sortOrder, size }) => {

  useEffect(() => {
    const id = (sortOrder !== DEFAULT_FILTER_VALUE) ? 'sort-selected' : '';

    document.querySelector('.ant-select-selector').setAttribute('id', id);
  }, [sortOrder]);


  return (
    <FilterWrapper>
      <div className="sort-dropdown-wrapper">
        <div className="sort-dropdown-label">{t('directives.listings.listingFilters.sortBy')}</div>
        <div className="sort-dropdown">
          <div className="select-wrapper">
            <Select
              defaultValue={DEFAULT_FILTER_VALUE}
              value={sortOrder}
              dropdownMatchSelectWidth
              onChange={(option) => {
                const id = (option !== DEFAULT_FILTER_VALUE) ? 'sort-selected' : '';
                $('.ant-select-selector').attr('id', id);
                updateSearchFilters({ s: option });
              }}
              size={size}
            >
              {ORDER_BY_OPTIONS.map(SelectOption)}
            </Select>
          </div>
        </div>
      </div>
    </FilterWrapper>
  );
};

SortSelector.propTypes = {
  updateSearchFilters: PropTypes.func.isRequired,
  sortOrder: PropTypes.string,
  size: PropTypes.string,
};

SortSelector.defaultProps = {
  sortOrder: DEFAULT_FILTER_VALUE,
  size: 'middle',
};

SelectOption.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default SortSelector;
